import { atom, useAtom } from "jotai";

import { MarketOrder } from "#/types/orders";

export const optionMarketOrderTypeAtom = atom<MarketOrder>(MarketOrder.IOC);

export const useOptionMarketOrderType = () => {
  const [optionMarketOrderType, setOptionMarketOrderType] = useAtom(
    optionMarketOrderTypeAtom,
  );
  const isImmediateOrCancel = optionMarketOrderType === MarketOrder.IOC;

  return {
    isImmediateOrCancel,
    optionMarketOrderType,
    setOptionMarketOrderType,
  };
};
